<script>
export default {
  name: 'stat-trend-card',
  props: {
    title: {
      type: String,
      default: 'Stat Title'
    },
    footerTitle: {
      type: String,
      default: 'footer title'
    },
    value: {
      type: [Number, String],
      default: 0
    },
    trend: {
      type: Boolean,
      default: true
    },
    trendValue: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    trendClass () {
      var trend = this.trend ? 'success' : 'danger'
      return `text-${trend}`
    },
    trendIcon () {
      var trend = this.trend ? 'up' : 'down'
      return `bx-trending-${trend}`
    },
    bgVariant () {
      return `bg-soft-${this.variant}`
    },
    textVariant () {
      return `text-${this.variant}`
    }
  }
}
</script>
<template>
  <b-card no-body v-bind="$attrs" v-on="$listeners">
    <b-card-title class="pt-3 px-3">{{ title }}</b-card-title>
    <b-card-body class="text-center px-3 pb-3 pt-0">
      <p class="lead text-center mb-0" style="font-size: 3.5vw">
        {{ value }}
      </p>

      <div class="text-center lead" :class="[trendClass]">
        <i class="bx font-size-16 align-middle mr-2" :class="[trendIcon]"></i
        >{{ trendValue }}
      </div>
      <small>{{ footerTitle }}</small>
    </b-card-body>

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </b-card>
</template>
